/* eslint-disable */
import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet } from 'react-native'


export default StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    height: 63,
    paddingBottom: 5,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 5,
  },

  title: {
    // match TextAreCellStyles.js
    color: 'black', //Fonts.style.color.dark, 
    //fontFamily: Fonts.style.font.regular, // light
    fontSize: 15,
  },

  textInput: {
    color: Fonts.style.primary,
    fontFamily: Fonts.style.font.regular, // light
    fontSize: 15,
    flex: 1,
    height: '100%',
    marginLeft: 20,
    textAlign: 'right',
  },
  warning : {
    color: 'orange',alignSelf: 'flex-end' ,margin : 10
  },
  error : {
    color: 'red'  ,alignSelf: 'flex-end' ,margin : 10
  
  }
})
